import styles from './ProblemSolvedCard.module.css';
import { clsx } from 'clsx';
import { ProblemsSolvedDescription } from '../../ProblemsSolvedDescription';
import { ProblemsSolvedTitle } from '../../ProblemsSolvedTitle';

type ProblemsSolvedCardProps = {
  title: string;
  problemText: string;
  solutionText: string;
  withHorizontalBorder?: boolean;
  withVerticalBorder?: boolean;
};

export const ProblemsSolvedCard = ({
  title,
  problemText,
  solutionText,
  withHorizontalBorder,
  withVerticalBorder,
}: ProblemsSolvedCardProps) => {
  return (
    <div
      className={clsx(styles.problemSolvedCardRoot, {
        [styles.horizontalBorder]: withHorizontalBorder,
        [styles.verticalBorder]: withVerticalBorder,
      })}>
      <ProblemsSolvedTitle title={title} />
      <ProblemsSolvedDescription problemText={problemText} solutionText={solutionText} />
    </div>
  );
};
